import {
  __name
} from "../../chunk-7QVYU63E.js";
import { isAxiosError } from "./axios.js";
const REDACTED_VALUE_STRING = "[FILTERED]";
const scrubSensitiveHeaders = /* @__PURE__ */ __name(async (error) => {
  if (!isAxiosError(error)) {
    throw error;
  }
  if (error.config?.auth?.username) {
    error.config.auth.username = REDACTED_VALUE_STRING;
  }
  if (error.config?.auth?.password) {
    error.config.auth.password = REDACTED_VALUE_STRING;
  }
  if (error.config?.headers?.has("authorization")) {
    error.config.headers.set("authorization", REDACTED_VALUE_STRING);
  }
  const params = error.config?.params;
  if (params && typeof params === "object" && params !== null && Object.hasOwn(params, "authToken")) {
    params["authToken"] = REDACTED_VALUE_STRING;
  }
  throw error;
}, "scrubSensitiveHeaders");
export {
  REDACTED_VALUE_STRING,
  scrubSensitiveHeaders
};
//# sourceMappingURL=interceptors.js.map